import React, { useState, useEffect } from "react";
import Textarea from "shared/Textarea/Textarea";
import FormItem from "./FormItem";
import { Grid2 as Grid } from "@mui/material";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';
import { Alert } from "@mui/material";
import api from "../../api";
import { updateUserBrand } from "../../redux/reducers/userReducer";
import { connect, useDispatch } from "react-redux";

const BrandDnaSection = ({ selectedBrand }) => {
  const dispatch = useDispatch();
  const initialValues = {
    brand_special: "",
    short_brand_story: "",
    sustainability: "",
  };

  const [inputValues, setInputValues] = useState(initialValues);
  const [sbState, setSBState] = useState({
    open: false,
  });
  const { open } = sbState;

  useEffect(() => {
    setInputValues(selectedBrand);
  }, [selectedBrand]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSaveChanges = () => {
    const payload = {
      id: selectedBrand.id,
      brand_special: inputValues.brand_special,
      short_brand_story: inputValues.short_brand_story,
      sustainability: inputValues.sustainability,
    }

    api.updateBrand(
      payload,
      (res) => {
        if (res.status === 200) {
          dispatch(updateUserBrand(res.data));
          openSuccessSnackbar({ vertical: 'bottom', horizontal: 'center' });
        }
      }
    );
  };

  const openSuccessSnackbar = (position: SnackbarOrigin) => {
    setSBState({ ...position, open: true });
  };

  const handleCloseSB = () => {
    setSBState({ ...sbState, open: false });
  };

  return (
    <>
      <div className="space-y-8">
        <FormItem label="USP / What makes the brand special?">
          <Textarea
            name="brand_special"
            rows={5}
            value={inputValues?.brand_special ?? ""}
            onChange={handleInputChange}
          />
        </FormItem>

        <FormItem label="Short Brand Story or Positioning Statement">
          <Textarea
            name="short_brand_story"
            rows={5}
            value={inputValues?.short_brand_story ?? ""}
            onChange={handleInputChange}
          />
        </FormItem>

        <FormItem label="Sustainability / Certifications (if relevant)">
          <Textarea
            name="sustainability"
            rows={5}
            value={inputValues?.sustainability ?? ""}
            onChange={handleInputChange}
          />
        </FormItem>

        <Grid container direction={"row"} className={"fullWidth"}>
          <div className={"flex-1"}></div>
          <ButtonPrimary onClick={handleSaveChanges}>Save Changes</ButtonPrimary>
        </Grid>
      </div>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={open}
        autoHideDuration={5000}
        onClose={handleCloseSB}
        message="Brand DNA Details Updated"
      >
        <Alert onClose={handleCloseSB} severity="success" variant="filled" sx={{ width: "100%" }}>
          Brand DNA Details Saved Successfully!
        </Alert>
      </Snackbar>
    </>
  );
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, { updateUserBrand })(BrandDnaSection);
